import Hdr from '../shared/Hdr'
import React from 'react'
import swal from 'sweetalert';
import { useState, useEffect } from 'react';
import { apiPath1, apiPath2 } from "../services/apiConfig";
//import {Link} from 'react-router-dom';
import TopBanner from '../components/TopBanner';
import { motion, AnimatePresence } from "framer-motion";

function Indent() {

  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const user_id = localStorage.getItem('user-id');
  const usrName = localStorage.getItem('userName');
  const sid = localStorage.getItem('store-id');

  const [toolName, setToolName] = useState("");
  const [display, setDisplay] = useState(false);
  const [displayUpdateIndent, setDisplayUpdateIndent] = useState(false);
  const [displayUpdateIndDet, setDisplayUpdateIndDet] = useState(false)
  const [displayApproveIndent, setDisplayApproveIndent] = useState(false)
  const [displayView, setDisplayView] = useState(false);
  const [displayUpdateIndentDet, setDisplayUpdateIndentDet] = useState('none');
  const [data, setData] = useState([]);
  const [indentID, setIndentID] = useState('')

  const [categoryData, setCategoryData] = useState([])
  const [uom, setUOM] = useState()
  const [purdate, setPurDate] = useState([])
  const [repdate, setRepDate] = useState([])
  const [cpu, setCPU] = useState()
  const [qty, setQTY] = useState()
  const [status, setStatus] = useState()
  const [category, setCategory] = useState()
  const [toolcode, setToolCode] = useState()
  const [description, setDescription] = useState()

  const [updToolName, setUpdToolName] = useState()
  const [updToolCode, setUpdToolCode] = useState()
  const [upddescription, setupdDescription] = useState()
  const [updcategoryID, setupdCategoryId] = useState()
  const [updUom, setupdUOM] = useState()
  const [updCPU, setupdCPU] = useState()
  const [updDop, setupdDOP] = useState()
  const [updQty, setupdQty] = useState()
  const [updStatus, setupdStatus] = useState()
  const [updDor, setupdDOR] = useState()
  const [updToolId, setupdToolID] = useState()
  const [updToolType, setupdToolType] = useState()
  const [tooltype, setToolType] = useState()

  const [storedata, setStores] = useState([])
  const [tools, setTools] = useState([])
  const [indentno, setIndetNO] = useState()
  const [indentdt, setIndetDt] = useState()
  const [storeId, setStoreId] = useState('0')
  const [remarks, setRemarks] = useState('')
  const [storeName, setStoreName] = useState()
  const [indentdetail, setIndentDet] = useState([])
  const [updIndentId, setupdIndentID] = useState()
  const [selectedUom, setSelectedUom] = useState()
  const [selectedToolCode, setSelectedToolCode] = useState('0')
  const [selectedToolName, setSelectedToolName] = useState()
  const [selectedToolID, setSelectedToolID] = useState()

  const [updQuantity, setupdQuantity] = useState()

  const [displayIndentDet, setDisplayIndentDet] = useState('none')
  const [categoryId, setCategoryId] = useState()

  const [updIndentNo, setUpdIndetNo] = useState()
  const [updIndentDt, setUpdIndentDt] = useState()
  const [updRemarks, setupdRemarks] = useState()
  const [updStoreId, setupdStoreId] = useState()
  const [updStoreName, setupdStoreName] = useState()
  const [updateData, setUpdateData] = useState([])
  const [updateStatus, setUpdateStatus] = useState()
  const [rejectionRemarks, setRejectionRemarks] = useState('')

  const [txt, setTxt] = useState('')

  const [IndDetStat, setIndDetStat] = useState(false)
  const [items, setItems] = useState([])

  const [updItemId, setUpdItemId] = useState()
  const [lineitem, setLineItem] = useState([])
  const [lineitemStatus, setLineItemStatus] = useState(false)

  const [selectedDate, setSelectedDate] = useState('');
  const [selectedStoreValue, setSelectedStoreValue] = useState('0')
  const [selectedCatagory, setSelectedCatagory] = useState('0')
  const [selectedTool, setSelectedTool] = useState('0')
  const [qnty, setQnty] = useState('')
  
   const [storeLinkedToUser,setStoreLinkedToUser] = useState([])
   const [approverList, setApproverList] = useState([])
   //const [approver, setApprover] = useState()
   //const [approverListStat, setApproverListStat] = useState()
   const [selectedApprover,setSelectedApprover] = useState('0')
   const [updApprover,setUpdApprover] = useState()

  useEffect(() => {
   //    alert(sid)
    getIndent2('', '')
    getToolCategory()
    getStores()
    getStoreLinkedToUser()
    GetApproverList()
  }, [])

  const containerVariants = {
    hidden: { x: "100vw" }, // Start off-screen to the right
    visible: { x: 0 },   // Slide into view
    exit: { x: "100vw" },  // Slide off-screen to the right when exiting
  };

  const transitionSettings = {
    duration: 0.5,
    type: "tween",
    ease: "easeInOut",
  };

  /* DELETE INDENT */

  function deleteOperation(id) {
    
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          DeleteIndent(id);
        }
        else {
          swal("Your record is safe!");
        }

      });

  }

  //DELETE INDIVIDUAL ITEM

  function deleteUpdatedItem(id) {
    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteIndentItem(id);
        }
        else {
          swal("Your record is safe!");
        }

      });

  }

  // FINAL DELETION OF INDIVIDUAL LINE IYTEM

  async function deleteIndentItem(props) {

    // alert(updIndentId)

    let result = await fetch(apiPath1 + "IndentItemDelete/" + props,
      {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    showSwal(result.status, result.msg)

    //  handleDeleteRow(props);
    getIndentItems(updIndentId)

  }

  /* final Indent deletion*/
  async function DeleteIndent(props) {


    let result = await fetch(apiPath1 + "IndentDelete/" + props,
      {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    showSwal(result.status, result.msg)

    getIndent2('', '')

  }


  async function updateItemOperation(id) {
   //  alert('update : '+id)

    let result = await fetch(apiPath1 + "IndentItem/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setUpdItemId(id)
//    setupdCategoryId(result.data.tool_category_id)

//    getTools(result.data.tool_category_id)
//    setupdToolID(result.data.tool_id);
    setUpdToolName(result.data.tool_name)
//    setupdUOM(result.data.uom)
    setupdQty(result.data.quantity)
    setupdStatus(result.data.status)
//    setSelectedUom(result.data.uom)

    if (result.data.status === 'Issued') {
      swal({
        title: "Fail!",
        text: "Issued Indent cannot be edited",
        icon: "error",
        button: "OK!",
      });

      return
    }

    openUpdateIndentDet()

  }


  async function updateIndentOperation(id) {


    let result = await fetch(apiPath1 + "Indent/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    if (result.data.indent_hdr.status === 'Approved') {
      swal({
        title: "Fail!",
        text: "Approved Indent cannot be edited",
        icon: "error",
        button: "OK!",
      });
      return
    }

    if (result.data.indent_hdr.status === 'Rejected') {
      swal({
        title: "Fail!",
        text: "Rejected Indent cannot be edited",
        icon: "error",
        button: "OK!",
      });
      return
    }

    setUpdateStatus(result.status)

    setupdIndentID(id)

    setUpdIndetNo(result.data.indent_hdr.indent_number);
    setUpdIndentDt(result.data.indent_hdr.indent_date);
    setupdRemarks(result.data.indent_hdr.requirement_remarks)
    setupdStoreId(result.data.indent_hdr.store_id)
    setupdStoreName(result.data.indent_hdr.store_name)
    setupdStatus(result.data.indent_hdr.status)
    setUpdApprover(result.data.indent_hdr.approver_id)

    getIndentItems(id)

    openUpdateIndent()

  }


  /* LIST OF ALL INDENT (for initial screen) */
  /*
    async function getIndent(){
      
      let result = await fetch(apiPath1+"Indents",
      {
        method:'GET',
        headers: {"Content-Type":"application/json",
                  "Accept":"application/json",
                  "Authorization": `Bearer ${token}`
                 },
      });
      result = await result.json( );
  
      if (result.status === true)
        {setData(result.data)}
      else
        {setData([])}
    }
  */
  /* LIST OF ALL INDENT (for initial screen) */

  async function getIndent2(stat, store) {

   //  alert('Indent2 -> stat :'+stat+', Store : '+store)

    let result = await fetch(apiPath1 + "IndentByStoreAndStatus",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "storeId": store,
          "status": stat
        })
      });


    result = await result.json();

    if (result.status === true) { setData(result.data) }
    else { setData([]) }
  }

  function openIndent() {
    setDisplay(true)
  }

  function closeIndent() {
    clearIndent()
    setDisplay(false)
  }

  function openView() {

    setDisplayView(true)
  }

  function closeView() {
    setDisplayView(false)
  }

  function closeApproveIndent() {
    setDisplayApproveIndent(false)
  }

  function openApproveIndent() {
    setDisplayApproveIndent(true)
  }  
  

  function openUpdateIndent() {
    setDisplayUpdateIndent(true)
  }

  function closeUpdateIndent() {
    setDisplayUpdateIndent(false)
  }

  function openUpdateIndentDet() {
    setDisplayUpdateIndDet(true)
  }

  function closeUpdateIndentDet() {
    setDisplayUpdateIndDet(false)
  }

  function closeIndentDet() {
    setDisplayIndentDet('none')
  }

  function indentHandler(e) {
    e.preventDefault()
    setToolName(e.target.value)
  }

  function indetDtUpdHandler(e) {
    e.preventDefault()
    setUpdIndentDt(e.target.value)
  }

  function approveUpdHandler(e){
    //alert(e.target.value)
    e.preventDefault()
   // selectedApprover(e.target.value)
    setUpdApprover(e.target.value)
  }

  function storeUpdHandler(e) {
    e.preventDefault()
    setupdStoreId(e.target.value)
  }

  function categoryHandler(e) {
    e.preventDefault()
    setSelectedCatagory(e.target.value)
    setCategory(e.target.value)
    getTools(e.target.value)
  }

  function updcategoryHandler(e) {
    e.preventDefault()
    setupdCategoryId(e.target.value)
    getTools(e.target.value)
  }

  function cpuHandler(e) {
    e.preventDefault()
    setCPU(e.target.value)
  }

  function cpuUpdHandler(e) {
    e.preventDefault()
    setupdCPU(e.target.value)
  }

  function qtyHandler(e) {
    e.preventDefault()
    setQnty(e.target.value)
    setQTY(e.target.value)
  }

  function uomHandler(e) {
    e.preventDefault()
    setUOM(e.target.value)
  }

  function updqtyHandler(e) {
    e.preventDefault()
    setupdQty(e.target.value)
    setTxt('')
  }

  function toolCodeHandler(e) {
//    alert(e.target.value +', '+e.target.options[e.target.selectedIndex].text)
    e.preventDefault()
 //   getToolDetail(e.target.value)
//    setSelectedToolID(e.target.value)
//const text = event.target.options[e.target.selectedIndex].text;

    setSelectedTool(e.target.options[e.target.selectedIndex].text)
    setSelectedUom(e.target.value)
   
  }

  function updtoolCodeHandler(e) {
   
    e.preventDefault()
 //   getToolDetail(e.target.value)
    setSelectedTool(e.target.value)
//    setupdToolID(e.target.value)
    
  }

  function updtoolTypeHandler(e) {
    e.preventDefault()
    setupdToolType(e.target.value)
  }

  function updateIndentHandler(e) {
    e.preventDefault()
    setUpdToolName(e.target.value)
  }


  function toolTypeHandler(e) {
    e.preventDefault()
    setToolType(e.target.value)
  }

  function descHandler(e) {
    e.preventDefault()
    setDescription(e.target.value)
  }

  function updRemarkHandler(e) {
    e.preventDefault()
    setupdRemarks(e.target.value)
  }


  /* MODIFY A INDENT HEADER */

  async function updateIndentHeader(id) {

  //alert('status' + stat)

    let result = await fetch(apiPath1 + "IndentUpdate/" + updIndentId, {
      method: 'PATCH',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "indent_number": updIndentNo,
        "indent_date": updIndentDt,
        "requirement_remarks": updRemarks,
        "store_id": updStoreId,
        "status": updStatus,
        "approver_id":updApprover
      })
    });

    result = await result.json();

    showSwal(result.status, result.msg)

    closeUpdateIndent();

    //getIndent2(updStoreId, updStatus)
    getIndent2('', '')

  }
/*
  async function getToolDetail(id) {

    let result = await fetch(apiPath1 + "Tool/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json()

    setSelectedUom(result.data[0].uom)
    setSelectedToolID(result.data[0].id)
    setSelectedToolCode(result.data[0].tool_code)
    setSelectedToolName(result.data[0].tool_description)

  }
*/


  /* LIST OF ALL TOOL CATAGORY List */

  async function getToolCategory() {

    let result = await fetch(apiPath1 + "ToolCategories",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setCategoryData(result.data) }
    else { setCategoryData([]) }
  }

  /* LIST OF ALL STORES LINKED TO USER*/
      async function getStoreLinkedToUser() {
  
        let result = await fetch(apiPath1 + "StoreLinkedToUser",
          {
            method: 'GET',
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "Authorization": `Bearer ${token}`
            },
          });
        result = await result.json();
   
        if (result.status === true) { setStoreLinkedToUser(result.data) 
        }
        else { setStoreLinkedToUser([]) }
      }
  

  /* LIST OF ALL STORES */
  async function getStores() {

    let result = await fetch(apiPath1 + "SiteStores",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setStores(result.data) }
    else { setStores([]) }
  }

/* LIST OF ALL TOOLS CATAGORYWISE 
  async function getTools(id) {

    let result = await fetch(apiPath1 + "ToolCategoryAndStatusWise",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "categoryId": id,
          "status": 'Ok'

        })
      });
    result = await result.json();

    if (result.status === true) { 
      setTools(result.data) }
    else { setTools([]) }
  }
*/

    /* LIST OF ALL TOOLS CATAGORYWISE */
    async function getTools(id) {

   //  alert(id)

    //  let result = await fetch(apiPath1 + "ToolCategoryWise/"+id,
    let result = await fetch(apiPath1 + "DistinctToolNamesByCategory/"+id,
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
      result = await result.json();

      if (result.status === true) { 
        setTools(result.data) }
      else {
//         swal()
         showSwal(result.status, result.msg) 
         setTools([])
      }
    }


  function storeHandler(e) {
    e.preventDefault()
    setSelectedStoreValue(e.target.value)
    setStoreId(e.target.value)
  }

  function IndentNumberHandler(e) {
    e.preventDefault()
    setIndetNO(e.target.value)
  }

  function indetDtHandler(e) {
    e.preventDefault()
    setSelectedDate(e.target.value)
    setIndetDt(e.target.value)
  }

  const [updRejectionRemarks, setUpdRejectionRemarks] = useState()
  const [updApproverName, setApproverName] = useState()

  async function viewDet(id, indentStat) {

    
    let result = await fetch(apiPath1 + "Indent/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setUpdateStatus(result.status)

    setupdIndentID(id)

    //alert(result.data.indent_hdr.store_id)

    setUpdIndetNo(result.data.indent_hdr.indent_number);
    setUpdIndentDt(result.data.indent_hdr.indent_date);
    setupdRemarks(result.data.indent_hdr.requirement_remarks)
    //setupdStoreId(result.data.indent_hdr.store_id)
    setupdStoreName(result.data.indent_hdr.store_name)
    setupdStatus(result.data.indent_hdr.status)
    setUpdRejectionRemarks(result.data.indent_hdr.rejected_remarks)
    setUpdApprover(result.data.indent_hdr.approver_id)
    setApproverName(result.data.indent_hdr.approver_name)
    
    getIndentItems(id)

    openView()
  }

  //const [indentdataForApproval, setIndentdataFormApproval] = useState([])


  async function getIndentForApprove(id) {

    let result = await fetch(apiPath1 + "Indent/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    if (result.data.indent_hdr.status === 'Approved') {
      swal({
        title: "Fail!",
        text: "Already Approved ! cannot modify",
        icon: "error",
        button: "OK!",
      });
      return
    }

    if (result.data.indent_hdr.status === 'Closed') {
      swal({
        title: "Fail!",
        text: "Already Closed ! can view from edit option",
        icon: "error",
        button: "OK!",
      });
      return
    }

    if (result.data.indent_hdr.status === 'Rejected') {
      swal({
        title: "Fail!",
        text: "Already Rejected ! cannot modify",
        icon: "error",
        button: "OK!",
      });
      return
    }

    setUpdateStatus(result.status)

    setupdIndentID(id)

    setUpdIndetNo(result.data.indent_hdr.indent_number);
    setUpdIndentDt(result.data.indent_hdr.indent_date);
    setupdRemarks(result.data.indent_hdr.requirement_remarks)
    setupdStoreId(result.data.indent_hdr.store_id)
    setupdStoreName(result.data.indent_hdr.store_name)
    setupdStatus(result.data.indent_hdr.status)
    setUpdApprover(result.data.indent_hdr.approver_id)

    // setUpdateData(result.data.indent_items)
    getIndentItems(id)

    openApproveIndent()
  }


  //New Approve Indent
  function approveIndent(id){

    let ItemString = GetApprovalData()

    if (ItemString === 'ALLREJECTED') {

      swal({
        title: "Are you sure?",
        text: "No item in this indent is approved, so the indent will be rejected",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            setRejectionRemarks('Rejected due to non approval of all items')
            rejectIndent(id)
            
          }
        });   
        return
    }
    
    saveApproveIndent(id, ItemString)
  }



  async function saveApproveIndent(id, ItemArray) {
     
    let body =   "[" + ItemArray + "]"
    //alert(id+', '+body)

    //alert (areAllRejected)

      let result = await fetch(apiPath1 + "IndentApprove/" + id,
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: body
        });

    result = await result.json();

    showSwal(result.status, result.msg)

    closeApproveIndent()
    setRejectionRemarks('')
    getIndent2(stat, storeId)
//    getIndent2('', '')

  }

/*
  async function getIndentItem(id) {

    let result = await fetch(apiPath1 + "IndentItems/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) {
      setIndDetStat(true)
      setIndentDet(result.data)
    }
    else {

      setIndDetStat(false)
      setIndentDet([])
    }

    setDisplayIndentDet('block')

  }

  */

/*
  async function approveIndentX(id) {
    //alert(id)

    let result = await fetch(apiPath1 + "IndentApprove/" + id,
      {
        method: 'PATCH',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    showSwal(result.status, result.msg)

    closeView()
    setRejectionRemarks('')
    getIndent2('', '')

  }
*/

  async function rejectIndent(id) {
    // alert('reject'+id+', '+rejectionRemarks)

    let result = await fetch(apiPath1 + "IndentReject/" + id,
      {
        method: 'PATCH',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "rejected_remarks": rejectionRemarks
        })
      });

    // alert('status :'+result.status)
    result = await result.json();

    showSwal(result.status, result.msg)

    closeApproveIndent()
    getIndent2('', '')
  }


  function addLineItem() {

   // alert(selectedTool)

    /*
    if (selectedToolCode === undefined || selectedToolCode === '0'){
      swal({
        title: "Fail!",
        text: "Select a Tool",
        icon: "error",
        button: "OK!",
      });

      return

    }
*/

  if (selectedTool === undefined || selectedTool === 'Select Tools' || selectedTool === '0'){
    swal({
      title: "Fail!",
      text: "Select a Tool",
      icon: "error",
      button: "OK!",
    });
    return
  }

  if (lineitem.some(row => row.tool_name === selectedTool)){
    swal({
      title: "Fail!",
      text: "Tool already exist",
      icon: "error",
      button: "OK!",
    });
    return
  }

    if (qty === undefined || qty <= 0) {
      swal({
        title: "Fail!",
        text: "Verify the Quantity",
        icon: "error",
        button: "OK!",
      }); 
      return
    }

    setLineItem(
      [
        ...lineitem,
        {
          id: lineitem.length,
//          tool_code: selectedToolCode,
//          tool_id: selectedToolID,
 //         tool_name: selectedToolName,
          tool_name: selectedTool,
          quantity: qty,
          uom: selectedUom
        }
      ]
    );
    setLineItemStatus(true)
    //setSelectedCatagory('0');
    //setSelectedTool('0')
   // setQnty('')
    ClearLineItems()

  }

  function ClearLineItems(){
    setSelectedToolCode('0')
    setSelectedTool('0')
    setSelectedToolID('')
    setSelectedToolName('')
    setQnty('')
    setQTY(0)
    setSelectedCatagory(0)
    setTools([])
  }


  /* DELETE INDENT LINE ITEM */

  function deleteItem(id) {

    swal({
      title: "Are you sure?",
      // text: "Once deleted, you will not be able to recover this data",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          handleDeleteRow(id);
        }
        else {
          swal("Your record is safe!");
        }

      });

  }

  const handleDeleteRow = (id) => {
    // alert(id)
    const updatedItems = lineitem.filter(item => item.id !== id);
    setLineItem(updatedItems);

    return true
  }

  const CreateTrIndent = () => {

    const newData = lineitem.map((tool, index) => [{
     // 'tool_id': tool.tool_id,
      'tool_name': tool.tool_name,
      'uom': tool.uom,
      'quantity': tool.quantity || 0 // Default to 0 if empty   
    }]);


    let ItemString = createDataString(newData)

    return ItemString

  };

  function createDataString(newData) {

    //alert('NewData '+JSON.stringify(newData))
    setItems([])
    const newItems = [];
    for (let i = 0; i < newData.length; i++) {
      newItems[i] = JSON.stringify(newData[i]).substring(1, JSON.stringify(newData[i]).length - 1)
    }

    setItems(newItems)
    //alert('NewItem '+newItems)

    return newItems


  }


  async function addIndent() {


    let ItemArray = CreateTrIndent()


    let body = "[" + JSON.stringify({
      "indent_date": indentdt,
      "store_id": storeId,
      "requirement_remarks": remarks,
      "approver_id":selectedApprover
    }) + ',' + ItemArray + "]"

    //alert('Body :'+body)

    

    let result = await fetch(apiPath1 + "IndentAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: body
    });

    result = await result.json();

    //alert(result.status)

    showSwal(result.status, result.msg)

    clearIndent()

    closeIndent()
    //   getIndentItem(indentID)
    getIndent2('', '')

  }

  function clearIndent() {

    setSelectedDate('')
    setSelectedStoreValue('0')
    setSelectedApprover('0')

    setRemarks('')

    setLineItemStatus(false)
    setLineItem([])
    setSelectedCatagory('0')
    setSelectedTool('0')
    setQnty('')
  }

  async function updateLineItem() {

    // alert(updItemId+': '+updIndentId+', '+updToolId+', '+updQty+', '+selectedUom)

    let result = await fetch(apiPath1 + "IndentItemUpdate/" + updItemId, {
      method: 'PATCH',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
//        "indent_id": updIndentId,
//        "tool_id": updToolId,
        "quantity": updQty
//        "uom": selectedUom
      })
    });

    result = await result.json();

    //showSwal(result.status,result.msg)    

    closeUpdateIndentDet()

    getIndentItems(updIndentId)


  }

  async function getIndentItems(id) {

    // alert(id)

    let result = await fetch(apiPath1 + "IndentItems/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    const dataWithChecked = result.data.map(item => ({
      ...item,
      checkeditem: true
    }));
  
    setUpdateData(dataWithChecked);

  //  setUpdateData(result.data)

  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  const [stat, setStat] = useState('0')

  function statusHandler(e) {

    e.preventDefault()
    setStat(e.target.value)

    if (e.target.value === '0') {
      getIndent2('', storeId)
    } else {

      // const selectedOption = e.target.options[e.target.selectedIndex];
      // const selectedText = selectedOption.text;

      // setStoreName(selectedText)

      //          getInventoryByStoreId(e.target.value)
      getIndent2(e.target.value, storeId)

    }
  }

  function storeSelector(e) {

    e.preventDefault()
    setStoreId(e.target.value)

    if (e.target.value === '0') {
      getIndent2(stat, '')
    } else {

      // const selectedOption = e.target.options[e.target.selectedIndex];
      // const selectedText = selectedOption.text;

      // setStoreName(selectedText)

      //          getInventoryByStoreId(e.target.value)
      getIndent2(stat, e.target.value)

    }
  }

  const [approvedItems, setApprovedItems] = useState(updateData.map(() => ''));
  const [rejectionText, setRejectionText] = useState(updateData.map(() => ''));
  const [isChecked, setIsChecked] = useState(true);
  const [areAllRejected,setAreAllRejected] = useState(false)
  

  function handleApproveCheck(index, isChecked){

    setUpdateData(prevData => {
      return prevData.map((item, i) => {
        if (i === index) {
          return { ...item, checkeditem: isChecked };
        }
        return item;
      });
    });

    let checkedValue = true
    
   // setIsChecked(isChecked)

    if (isChecked) {
  //    alert('checked')
      checkedValue = true
    }else{
      
      checkedValue = false
 //     alert('un-checked '+checkedValue)
    }

    Approvalarray(checkedValue, index)

  } 

function Approvalarray(checkedValue, index){
  const newApproval = [...approvedItems];
  newApproval[index] = checkedValue;
  setApprovedItems(newApproval);
}


const GetApprovalData = () => {
 
//console.log('approve items ',approvedItems[0])

  const newData = updateData.map((tool, index) => [{
//    'tool_id': tool.tool_id,
    'tool_name': tool.tool_name,
    'remarks': rejectionText[index] || '',
    'is_approved': approvedItems[index] !== undefined ? approvedItems[index] : true
  }]);

  const AllRejected = newData.every(item => item[0].is_approved === false);

  //setAreAllRejected(AllRejected)

  let ItemString = createDataString(newData)

  if (AllRejected === true){
    ItemString = "ALLREJECTED"
  }

  return ItemString
};


function handleRejection(index, textValue){
 // alert('index'+index + 'TextValue'+textValue)

  const newRejectionText = [...rejectionText];
  newRejectionText[index] = textValue;
  setRejectionText(newRejectionText);


  //console.log('text', rejectionText)
}


async function GetApproverList(){

  let result = await fetch(apiPath1 + "IndentApproversList",
    {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });
  result = await result.json();

  //setApproverListStat(result.status)
  if (result.status === true) { setApproverList(result.data) }
  else { setApproverList([]) }

}

function approveHandler(e){
 // alert(e.target.value)
  e.preventDefault()
  setSelectedApprover(e.target.value)
}

  return (

    <div style={{ 'width': '100%', 'height': '100vh' }}>
      <Hdr />
      <TopBanner name={'Indent List'} />

      <div className="row p16" style={{ 'height': '95%' }}>
        <div className=" c12-l-12 cont__content-parent p4" style={{ 'height': '100%' }}>
          {/* CTA SECTION */}
          <div className="row mb16">
            {/* SELECT FILTER SECTION */}
            <div className="c12-l-6">
              <div className='row'>
                <div className="c12-g-l-6 px4" >
                  <p className='txt-darkblue ml4 mb4'>Select Status</p>
                  <select className="small" onChange={statusHandler}>
                    <option value="">All Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Approved">Approved</option>
                    <option value="Closed">Closed</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                </div>

                <div className="c12-g-l-6 px4">
                  <p className='txt-darkblue ml4 mb4'>Select Store</p>
                  <select className="small" onChange={storeSelector}>
                    <option value="0" >Select Store</option>
                    {
                      storedata.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.store_name}</option>
                      )
                    }
                  </select>
                </div>
              </div>
            </div>
            <div className="c12-l-4"></div>

            {/* ADD BUTTON */}
            <div className="c12-l-2 align-bottom-right">
              <button onClick={openIndent} type="button" name="button"
                className="btn xl gradient round">Create New Indent</button>
            </div>
          </div>

          {/* DATA TABLE SECTION */}
          <div className="c12-l-12 cont__content p4" style={{ 'height': '85%' }}>
            <table style={{ 'display': 'block' }}>
              <thead className='thead-blue'>
                <tr>
                  <th className="th-border" width="5%">Id</th>
                  <th className="th-border" width="10%">Indent No</th>
                  <th className="th-border left" width="15%">Date</th>
                  <th className="th-border left" width="25%">Store</th>
                  <th className="th-border left" width="15%">Status</th>
                  <th className="th-border" width="15%">View</th>
                  <th className="th-border" width="15%">Edit</th>
                  <th className="th-border" width="15%">Approval</th>
                  <th className="th-border" width="15%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  data.map((item, index) =>
                    <tr className="tr-two-color-grey" key={index}>
                      <td className="center">{item.id}</td>
                      <td className="center">{item.indent_number}</td>
                      <td className="">{item.indent_date}</td>
                      <td className="">{item.store_name}</td>
                      <td className="">{item.status}</td>
                      <td onClick={() => { viewDet(item.id, item.status) }} className="center"><img src={require('../asset/icons/adm_view_16.png')} alt="" /></td>
                      {
                        (item.status === 'Pending' ?
                          (
                            <td onClick={() => { updateIndentOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>  
                           )
                           :
                           <td className="center"><img src={require('../asset/icons/adm_edit_disabled.png')} alt="" /></td>
                          )}
                      <td onClick={() => { getIndentForApprove(item.id) }} className="center"><img src={require('../asset/icons/approve_24.png')} alt="" /></td>
                      
                      {
                        (item.status === 'Pending' ?
                          (
                            <td onClick={() => { deleteOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
                           )
                           :
                            <td className="center"><img src={require('../asset/icons/adm_del_disabled.png')} alt="" /></td>
                          )}
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>

        {/* A.SCREEN FROM ADDING NEW INDENT   */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {display && (        
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-2">
                  <h3 className='txt-subtlewhite'>Add Indent</h3>
                </div>
                <div className="c12-l-9"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeIndent}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">

                  <div className="row">
                    <div className='c12-l-4'>
                      <div className="row">
                        <div className='c12-l-6'>
                          <p>Indent Number</p>
                          <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            placeholder="New Indent" disabled={true} />
                        </div>
                        <div className='c12-l-6'>
                          <p>Indent Date</p>
                          <input type="date" value={selectedDate} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            onChange={indetDtHandler} />
                        </div>
                      </div>
                    </div>

                    <div className='c12-l-8 pr4'>
                      <div className="row">
                        <div className='c12-l-8'>
                          <p>Select Store (Indentor)</p>
                          <select className="small" value={selectedStoreValue} onChange={storeHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                            {(sid === '0' ?
                              <option value="0" >All Stores</option> 
                              : <option value="-1" >Select Store</option> 
                            )}
                            {
                              storeLinkedToUser.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.store_name}</option>
                              )
                            }
                          </select>
                        </div>
                        <div className='c12-l-4'>
                          <p>Select Approver</p>
                          <select className="small" value={selectedApprover} onChange={approveHandler} style={{'marginTop': '1px' }}>
                            <option value="0" >Select Approver</option>
                            {
                              approverList.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.name}</option>
                              )
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className='c12-l-3'><p style={{ 'marginTop': '5px' }}>Requirement Remarks</p></div>
                      <div className='c12-l-9'>
                        <textarea type="text" value={remarks} className="box small" style={{ 'marginTop': '1px' }} rows="3"
                          placeholder="remarks" onChange={(e) => setRemarks(e.target.value)} />
                      </div>
                    </div>
                    <div className='row box border-bottom-dark my8'></div>
                    <div className="row">
                      <div className='c12-l-3'>
                        <p style={{ 'marginTop': '5px' }}>Select Categoty</p>
                        <select className="small" value={selectedCatagory} onChange={categoryHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                          <option value="0" >Select Catagory</option>
                          {
                            categoryData.map((item, index) =>
                              <option key={item.id} value={item.id}>{item.category_name}</option>
                            )
                          }
                        </select>
                      </div>
                      <div className='c12-l-4'>
                        <p style={{ 'marginTop': '5px' }}>Select Tools</p>
                        <select className="small" onChange={toolCodeHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                          <option value="0" >Select Tools</option>
                          {
                            tools.map((item, index) =>
                              /* <option key={item.id} value={item.id}>{item.tool_description}</option> */
                              <option key={item.name} value={item.uom}>{item.tool_name}</option>
                            )
                          }
                        </select>
                      </div>
                      <div className='c12-l-2'>
                        <p style={{ 'marginTop': '5px' }}>Quantity</p>
                        <input type="number" value={qnty} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                          placeholder="Quantity" onChange={qtyHandler} />

                      </div>
                      <div className='c12-l-3'>
                        <button onClick={addLineItem} name='qty' type="button" style={{ 'marginTop': '22px', 'marginLeft': '35px' }}
                          className="btn gradient round">Add Tools</button>
                      </div>
                    </div>

                    <div className="row style={{'height':'95%'}}">
                      <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                        <table style={{ 'height': '200px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                          <thead className='thead-grey'>
                            <tr>
                             {/* <th className="th-border left" width="25%">Tool Code</th> 
                              <th className="th-border" width="8%">Id</th>   */}
                              <th className="th-border left" width="6%">Srl</th>
                              <th className="th-border left" width="60%">Tool Name</th>
                              <th className="th-border center" width="25%">Quantity</th>
                              <th className="th-border left" width="25%">Unit</th>
                              <th className="th-border" width="10%">Delete</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              (lineitemStatus === true ?
                                (
                                  lineitem.map((item, index) =>
                                    <tr className="tr-border" key={index}>
                                 {/*  <td className="center">{item.id}</td>  
                                      <td hidden className="">{item.tool_id}</td>  
                                      <td className="">{item.tool_code}</td>  */}
                                      <td className="">{index+1}</td>
                                      <td className="">{item.tool_name}</td>
                                      <td className="center">{item.quantity}</td>
                                      <td className="">{item.uom}</td>
                                      <td onClick={() => { deleteItem(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
                                      {/*
                            <td onClick={()=>{updateIndDetOperation(item.id)}} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                            
                          */}
                                    </tr>
                                  ))
                                : <tr><td>No data</td></tr>)
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <button onClick={addIndent} type="button" name="button"
                      className="btn gradient round">Save Indent</button>
                  </div>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>          

        {/* SCREEN FROM MODIFYING INDENT */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayUpdateIndent && ( 
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-3">
                  <h3 className='txt-subtlewhite' >Update Indent</h3>
                </div>
                <div className="c12-l-8"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeUpdateIndent}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>
              <div className="row mt8 px16">
                <div className="c12-l-12">
                  <div className="row">
                    <div className='c12-l-4'>
                      <div className="row">
                        <div className='c12-l-6'>
                          <p>Indent Number</p>
                          <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updIndentNo} />
                        </div>
                        <div className='c12-l-6'>
                          <p>Indent Date</p>
                          <input type="date" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updIndentDt} onChange={indetDtUpdHandler} />
                        </div>
                      </div>
                    </div>
                    <div className='c12-l-2'>
                      <p>Indent Status</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updStatus} />
                    </div>

                    <div className='c12-l-6'>
                      <div className="row">
                        <div className='c12-l-8'>
                          <p>Select Store (Indentor)</p>
                          <select className="small" onChange={storeUpdHandler} style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updStoreId}>
                            <option value="0" >Select Store</option>
                            {
                              storedata.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.store_name}</option>
                              )
                            }
                          </select>
                        </div>
                        <div className='c12-l-4'>
                          <p>Select Approver</p>
                          <select className="small" value={updApprover} onChange={approveUpdHandler} style={{'marginTop': '1px' }}>
                            <option value="0" >Select Approver</option>
                            {
                              approverList.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.name}</option>
                              )
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className='c12-l-3'><p style={{ 'marginTop': '5px' }}>Requirement Remarks</p></div>
                      <div className='c12-l-9'>
                        <textarea type="text" className="box small" style={{ 'marginTop': '1px' }} rows="3"
                          placeholder="remarks" value={updRemarks} onChange={updRemarkHandler} />
                      </div>
                    </div><br />
                    <div className="row style={{'height':'95%'}}">
                      <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                        <table style={{ 'height': '300px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                          <thead className='thead-grey'>
                            <tr>
                             <th className="th-border" width="5%">Id</th>
                           {/*}   <th className="th-border left" width="15%">Tool Code</th>  */}
                              <th className="th-border left" width="30%">Tool Name</th>
                              <th className="th-border center" width="15%">Indent Qty</th>
                              <th className="th-border left" width="5%">Unit</th>
                              <th className="th-border left" width="10%">Issued Status</th>
                              <th className="th-border left" width="20%">User</th>
                              <th className="th-border" width="8%">Edit</th>
                              <th className="th-border" width="8%">Delete</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              (updateStatus === true ?
                                (
                                  updateData.map((item, index) =>
                                    <tr className="tr-border tr-two-color-blue" key={index}>

                                      <td className="center">{item.id}</td>
{/*}                                      <td hidden className="">{item.tool_id}</td>
                                      <td className="">{item.tool_code}</td>  */}
                                      <td className="">{item.tool_name}</td>
                                      <td className="center">{item.quantity}</td>
                                      <td className="">{item.uom}</td>
                                      <td className="">{item.status}</td>
                                      <td className="">{item.user_name}</td>
                                      <td onClick={() => { updateItemOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                                      <td onClick={() => { deleteUpdatedItem(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
                                    </tr>
                                  ))
                                : <tr><td>No data</td></tr>)
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <button className="btn gradient round large" type="button" onClick={() => { updateIndentHeader({ updIndentId }) }}>Update Indent</button>

                  </div>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>  


        {/* SCREEN FROM MODIFYING LINE ITEM */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayUpdateIndDet && ( 
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="updateIndent" className="cont__lineitem">
            <form className="" action="" method="">
              <div className="row box grey corner-round-tr">
                <div className="c12-l-5">
                  <h6 className='txt-subtlewhite pt8'>Update Items</h6>
                </div>
                <div className="c12-l-6"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeUpdateIndentDet}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">

                  <p>Indent Number</p>
                  <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                    value={updIndentNo} />
{/*
                  <p style={{ 'marginTop': '5px' }}>Select Categoty</p>
                  <select className="small" onChange={updcategoryHandler} style={{ "width": '98%', 'marginTop': '1px' }}
                    value={updcategoryID}>
                    <option value="0" >Select Catagory</option>
                    {
                      categoryData.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.category_name}</option>
                      )
                    }
                  </select>

                  <p style={{ 'marginTop': '5px' }}>Select Tools</p>
                  <select className="small" onChange={updtoolCodeHandler} style={{ "width": '98%', 'marginTop': '1px' }}
                    value={updToolId}>
                    <option value="0" >Select Tools</option>
                    {
                      tools.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.tool_name}</option>
                      )
                    }
                  </select>
*/}

                  <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                  value={updToolName} />

                  <p style={{ 'marginTop': '5px' }}>Quantity</p>
                  <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                    placeholder="Quantity" value={updQty} onChange={updqtyHandler} /> <br />

                  <button className="btn gradient round large" type="button" onClick={updateLineItem}>Update Item</button>

                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>   

        {/* VIEW (Indent Details) */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayView && (   
            <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-3">
                  <h3 className='txt-subtlewhite'>View Indent Details</h3>
                </div>
                <div className="c12-l-8"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeView}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">
                  <div className="row">
                    <div className='c12-l-4'>
                      <div className="row">
                        <div className='c12-l-6'>
                          <p>Indent Number</p>
                          <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updIndentNo} />
                        </div>
                        <div className='c12-l-6'>
                          <p>Indent Date</p>
                          <input type="date" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updIndentDt} />
                        </div>
                      </div>
                    </div>
                    <div className='c12-l-2'>
                      <p>Indent Status</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updStatus} />
                    </div>
                    <div className='c12-l-6'>
                      <div className="row">
                        <div className='c12-l-8'>
                          <p>Indent From Store</p>
                          <input type="text" className="box small" style={{ 'marginTop': '1px','width':'99%' }} value={updStoreName} />
                          {/*
                          <select className="small" style={{ "width": '98%', 'marginTop': '1px' }} value={updStoreId}> 
                            <option value="0" >Select Store</option>
                            {
                              storedata.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.store_name}</option>
                              )
                            }
                          </select>
                          */}
                        </div>
                        <div className='c12-l-4'>
                          <p>Approved By</p>
                          <input type="text" className="box small" style={{ 'marginTop': '1px' }} value={updApproverName} />
                          {/*
                          <select className="small" value={updApprover} style={{'marginTop': '1px','marginLeft':'2px' }}> 
                            <option value="0" >Select Approver</option>
                            {
                              approverList.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.name}</option>
                              )
                            }
                          </select>
                          */}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className='c12-l-3'><p style={{ 'marginTop': '5px' }}>Requirement Remarks</p></div>
                      <div className='c12-l-9'>
                        <textarea type="text" className="box small" style={{ 'marginTop': '1px' }} rows="3"
                          placeholder="remarks" value={updRemarks} />
                      </div>
                    </div><br />
                    <div className="row">
                    <div className='c12-l-3'><p style={{ 'marginTop': '5px' }}>Rejeaction Remarks</p></div>
                    <div className='c12-l-9'>
                      <textarea type="text" className="box small" style={{ 'marginTop': '1px' }} rows="3"
                        placeholder="remarks" value={updRejectionRemarks} />
                    </div>
                  </div><br />
                    <div className="row style={{'height':'95%'}}">
                      <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                        <table style={{ 'height': '330px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                          <thead className='thead-grey'>
                            <tr>
                              <th className="th-border" width="5%">Id</th>
                            {/*  <th className="th-border left" width="13%">Tool Code</th>  */}
                              <th className="th-border left" width="35%">Tool Name</th>
                              <th className="th-border center" width="15%">Indent Qty</th>
                              <th className="th-border center" width="5%">Unit</th>
                              <th className="th-border center" width="15%">Item Approved</th>
                              <th className="th-border center" width="10%">Issued Qty</th>
                              <th className="th-border left" width="10%">Issue Status</th>                             
                              <th className="th-border center" width="20%">Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              (updateStatus === true ?
                                (
                                  updateData.map((item, index) =>
                                    <tr className="tr-border tr-two-color-blue" key={index}>

                                      <td className="center">{item.id}</td>
                                      <td hidden className="">{item.tool_id}</td>
                                  {/*    <td className="">{item.tool_code}</td> */}
                                      <td className="">{item.tool_name}</td>
                                      <td className="center">{item.quantity}</td>
                                      <td className="center">{item.uom}</td>
                                      <td className="center">{(item.is_approved === 1) ? <img src={require('../asset/icons/adm_ok.png')} alt="" /> : <img src={require('../asset/icons/adm_close.png')} alt="" />}</td>
                                      <td className="center">{item.qty_issued}</td>
                                      <td className="">{item.status}</td>
                                      <td className="center">{item.remarks}</td>
                                      
                                    </tr>
                                  ))
                                : <tr><td>No data</td></tr>)
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
{/*
                    <div className="row my4">
                      <div className='c12-l-4 align-left'>
                        <button onClick={() => { approveIndent(updIndentId) }}
                          type="button"
                          name="approvebutton"
                          className="btn gradient round large">
                          Approve Indent
                        </button>
                      </div>
                      <div className='c12-l-8'>
                        <p className='py8'>Rejection Remarks</p>
                        <textarea
                          type="text"
                          className="box small"
                          rows="2"
                          placeholder="Rejection Remarks"
                          onChange={(e) => setRejectionRemarks(e.target.value)}
                        />
                        <button
                          onClick={() => { rejectIndent(updIndentId) }}
                          type="button"
                          name="rejectbutton"
                          className="btn gradient round large ">
                          Reject Indent
                        </button>
                      </div>
                    </div>
                    */}
                  </div>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>  

        {/* APPROVE INDENT (Indent Details) */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayApproveIndent && (   
            <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-3">
                  <h3 className='txt-subtlewhite'>Indent Approval</h3>
                </div>
                <div className="c12-l-8"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeApproveIndent}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">
                  <div className="row">
                    <div className='c12-l-4'>
                      <div className="row">
                        <div className='c12-l-6'>
                          <p>Indent Number</p>
                          <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updIndentNo} />
                        </div>
                        <div className='c12-l-6'>
                          <p>Indent Date</p>
                          <input type="date" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updIndentDt} />
                        </div>
                      </div>
                    </div>
                    <div className='c12-l-8'>
                      <div className="row">
                        <div className='c12-l-8'>
                          <p>Indent from Store</p>
                          <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updStoreName} />
                          {/*
                          <select className="small" style={{ "width": '98%', 'marginTop': '1px' }}
                            value={updStoreId}>
                            <option value="0" >Select Store</option>
                            {
                              storedata.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.store_name}</option>
                              )
                            }
                          </select>
                          */}

                        </div>
                        <div className='c12-l-4'>
                          <p>Select Approver</p>
                          <select className="small" value={updApprover} style={{'marginTop': '1px' }}>                          
                            <option value="0" >Select Approver</option>
                            {
                              approverList.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.name}</option>
                              )
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className='c12-l-3'><p style={{ 'marginTop': '5px' }}>Requirement Remarks</p></div>
                      <div className='c12-l-9'>
                        <textarea type="text" className="box small" style={{ 'marginTop': '1px' }} rows="3"
                          placeholder="remarks" value={updRemarks} />
                      </div>
                    </div><br />
                    <div className="row style={{'height':'95%'}}">
                      <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                        <table style={{ 'height': '250px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                          <thead className='thead-grey'>
                            <tr>
                              <th className="th-border" width="5%">Id</th>
                              <th className="th-border left" width="10%">Tool Code</th>
                              <th className="th-border left" width="30%">Tool Name</th>
                              <th className="th-border center" width="10%">Quantity</th>
                              <th className="th-border center" width="5%">Unit</th>
                              <th className="th-border left" width="5%">Status</th>
                              <th className="th-border center" width="10%">Issued Qty</th>
                              <th className="th-border center" width="10%">Approve</th>
                              <th className="th-border center" width="30%">Rejection Cause</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              (updateStatus === true ?
                                (
                                  updateData.map((item, index) =>
                                    <tr className="tr-border tr-two-color-blue" key={index}>

                                      <td className="center">{item.id}</td>
                                      <td hidden className="">{item.tool_id}</td>
                                      <td className="">{item.tool_code}</td>
                                      <td className="">{item.tool_name}</td>
                                      <td className="center">{item.quantity}</td>
                                      <td className="center">{item.uom}</td>
                                      <td className="">{item.status}</td>
                                      <td className="center">{item.qty_issued}</td>
                                      <td className="center">
{/*                                        <input type="checkbox" checked={isChecked} name="Approved" 
                                        onChange={(e) => handleApproveCheck(index, e.target.checked)}
                                         />
*/}
                                         <input type="checkbox" checked={item.checkeditem} name="Approved" 
                                         onChange={(e) => handleApproveCheck(index, e.target.checked)}
                                          />

                                      </td>
                                      <td className="left">
                                      {item.checkeditem ?
                                        null:
                                          (
                                          <div>
                                            <input 
                                              type="text"
                                              className="box small" style={{ 'textAlign': 'right' }} name="rejectText"
                                              onChange={(e) => handleRejection(index, e.target.value)} />
                                          </div>
                                          )
                                        }
                                      </td>
                                    </tr>
                                  ))
                                : <tr><td>No data</td></tr>)
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="row my4">
                      <div className='c12-l-4 align-left'>
                        <button onClick={() => { approveIndent(updIndentId) }}
                          type="button"
                          name="approvebutton"
                          className="btn gradient round large">
                          Approve Indent
                        </button>
                      </div>
                      <div className='c12-l-8'>
                        <p className='py8'>Rejection Remarks</p>
                        <textarea
                          type="text"
                          className="box small"
                          rows="2"
                          placeholder="Rejection Remarks"
                          onChange={(e) => setRejectionRemarks(e.target.value)}
                        />
                        <button
                          onClick={() => { rejectIndent(updIndentId) }}
                          type="button"
                          name="rejectbutton"
                          className="btn gradient round large ">
                          Reject Indent
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>  

        </div>
      </div>
    </div>
  );
}

export default Indent;
